import React from 'react';
import PropTypes from 'prop-types';
import { FormInput } from '@getro/rombo';

export const EmailField = ({ field, value, onChange, onBlur, error, disabled }) => {
  const fieldName = field.id?.toString() || field.tempId;

  return (
    <FormInput
      label={field.label}
      labelExtra={field.required ? 'Required' : ''}
      type="email"
      disabled={disabled}
      helpText={field.helperText}
      inputProps={{ style: { height: '48px' } }}
      field={{
        name: fieldName,
        value,
        onChange,
        onBlur,
      }}
      form={{
        errors: { [fieldName]: error },
        touched: { [fieldName]: !!error },
      }}
    />
  );
};

EmailField.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tempId: PropTypes.string,
    label: PropTypes.string.isRequired,
    required: PropTypes.bool.isRequired,
    helperText: PropTypes.string,
  }).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  error: PropTypes.string,
  disabled: PropTypes.bool,
};

EmailField.defaultProps = {
  value: '',
  onChange: undefined,
  onBlur: undefined,
  error: undefined,
  disabled: false,
};
